<template>
<div class="chapter">
<div class="inner_page">
<p class="break"> </p>
<h3 style="font-weight:normal">CONTENTS</h3>
<p class="mediumspace">
</p><p class="tocitem"><a href="#/html/06_introduction">Introduction</a></p>
<p class="smallspace">
</p><p class="tocitem"><a href="#/html/07_chap1">The First Word</a></p>
<p class="smallspace">
</p><p class="tocitem"><span href="#/html/08_chap2" title="Link target outside of Sample">The Second Word</span></p>
<p class="smallspace">
</p><p class="tocitem"><span href="#/html/09_chap3" title="Link target outside of Sample">The Third Word</span></p>
<p class="smallspace">
</p><p class="tocitem"><span href="#/html/10_chap4" title="Link target outside of Sample">The Fourth Word</span></p>
<p class="smallspace">
</p><p class="tocitem"><span href="#/html/11_chap5" title="Link target outside of Sample">The Fifth Word</span></p>
<p class="smallspace">
</p><p class="tocitem"><span href="#/html/12_chap6" title="Link target outside of Sample">The Sixth Word</span></p>
<p class="smallspace">
</p><p class="tocitem"><span href="#/html/13_chap7" title="Link target outside of Sample">The Seventh Word</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_contents.vue?4808101c